import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import {
  FlexContainer,
  FlexContainerVertical
} from '../../../../../../layout/Flex';
import { WithBreakpoints } from '../Breakpoints';
import { EmployeeAppCard } from '../EmployeeAppCard';

export const InfoCardsContainerLarge = styled('div')((p) => ({
  marginTop: p.theme.spacing(4),
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: p.theme.spacing(3)
}));

export const InfoCardsContainerMedium = styled('div')((p) => ({
  width: '100%',
  display: 'flex',
  gap: p.theme.spacing(3)
}));

export const InfoCardsContainerSmall = styled('div')((p) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: p.theme.spacing(3)
}));

export const InfoCardsContainer: React.FC = ({ children }) => (
  <WithBreakpoints
    lg={<InfoCardsContainerLarge>{children}</InfoCardsContainerLarge>}
    md={<InfoCardsContainerMedium>{children}</InfoCardsContainerMedium>}
    sm={<InfoCardsContainerMedium>{children}</InfoCardsContainerMedium>}
    xs={<InfoCardsContainerSmall>{children}</InfoCardsContainerSmall>}
  />
);

export const InfoCard: React.FC<{
  title: React.ReactNode;
  subTitle?: React.ReactNode;
  icon: React.ReactNode;
}> = ({ title, subTitle, icon, children }) => {
  return (
    <EmployeeAppCard>
      <FlexContainer fullWidth justifyContent="space-between" marginBottom={2}>
        <FlexContainerVertical spacing={0}>
          <Typography variant="h4">{title}</Typography>
          {subTitle && (
            <Typography variant="caption">
              <strong>{subTitle}</strong>
            </Typography>
          )}
        </FlexContainerVertical>
        <div>{icon}</div>
      </FlexContainer>
      {children}
    </EmployeeAppCard>
  );
};
